import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/pagination';
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import SwiperCore from 'swiper';
import { useState, useEffect } from 'react';
import "../styles/swiper.css"


SwiperCore.use([Autoplay]);

const imgSwiperList = Array.from({ length: 29 }, (_, i) => `/swiper/img-swiper${29 - i}.jpg`);
const imgList = [
    '/swiper/IMG_3809.jpg',
    '/swiper/IMG_3811.jpg',
    '/swiper/IMG_3813.jpg',
    '/swiper/IMG_3814.jpg',
    '/swiper/IMG_3815.jpg',
    '/swiper/IMG_3818.jpg',
    '/swiper/IMG_3819.jpg',
    '/swiper/IMG_3823.jpg',
    '/swiper/IMG_3825.jpg',
    '/swiper/IMG_3828.jpg',
    '/swiper/IMG_3830.jpg',
    '/swiper/IMG_3832.jpg',
    '/swiper/IMG_3837.jpg',
];

const allImages = [...imgSwiperList.filter(img => img !== '/swiper/img-swiper14.jpg'), ...imgList];

export const EvenSwiper: React.FC = () => {
    
    const [imageOrientations, setImageOrientations] = useState<Record<string, 'landscape' | 'portrait'>>({});

    useEffect(() => {
        const orientations: Record<string, 'landscape' | 'portrait'> = {};
        
        allImages.forEach((src) => {
            const img = new Image();
            img.onload = () => {
                const isLandscape = img.width > img.height;
                orientations[src] = isLandscape ? 'landscape' : 'portrait';
                setImageOrientations({ ...orientations });
            };
            img.src = src;
        });
    }, []);

    if (allImages.length === 0) return <></>
    return (
        <div className="swiper-section">
            <div className='swiper-button-prev'>
                <img src='/images/icon-prev.png' alt='' />
            </div>
            <Swiper
                modules={[Navigation, Pagination]}
                navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    disabledClass: 'disable'
                }}
                pagination={{
                    clickable: true,
                }}
                slidesPerView={1}
                spaceBetween={0}
                breakpoints={{ 800: { slidesPerView: 2, spaceBetween: 60 } }}
                autoplay
                loop={true}
            >
                {
                    allImages.map((item: string) => {
                        const orientation = imageOrientations[item] || 'portrait';
                        return <SwiperSlide key={item}>
                            <div className={`swiper-image-container ${orientation === 'landscape' ? 'landscape' : 'portrait'}`}>
                                <img src={item} alt="" className="swiper-image" />
                            </div>
                        </SwiperSlide>
                    })
                }
            </Swiper>
            <div className='swiper-button-next'>
                <img src='/images/icon-next.png' alt='' />
            </div>
        </div>
    );
};
